import { StackLayout } from '@leagueplatform/genesis-core';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';

const MasonryDriver = getMasonryDriver({
  rootNodeId: 'medicare-prescription-payment-plan$root',
});

export const MedicarePrescriptionPaymentPlanMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <MasonryEngine driver={MasonryDriver} />
  </StackLayout>
);
